
import { defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import store from "@/store";
import { ICoursesModel } from "@/interfaces/modules";
import CoursesService from "@/api/Aula/CoursesSevice";
import GroupsContent from "./GroupsContent.vue";
import CourseGroupsCapacity from "./CourseGroupCapacity.vue";
import HeadquartersService from "@/api/Configuration/HeadquartersService";
import JourneysService from "@/api/Configuration/JourneysService";
import CategoriesService from "@/api/Configuration/CategoriesService";
import type { IJourneysModel, IHeadquartersModel, ICategoriesModel } from "@/interfaces/modules";

export default defineComponent({
  name: "AddCourse",
  components: {
    GroupsContent,
    CourseGroupsCapacity
  },
  data() {
    const route = useRoute();
    const file = ref<File | null>(null);
    return {
      courseId: route.params.Id || 0,
      file: null as File | null,
      roles: [] as any[],
      categories: [] as ICategoriesModel[],
      form: {
        loading: true,
        dialog: false,
        wasValidated: false,
        valid: false,
        record: {} as ICoursesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      journeys: [] as IJourneysModel[],
      headquarters: [] as IHeadquartersModel[]
    };
  },
  watch: {
    'form.record.HeadquarterId'(val: any) {
      this.form.wasValidated = !val || !this.form.record.HeadquarterId;
    }
  },
  async mounted() {
    await this.load();
    if (parseInt(this.courseId as any) > 0)
      this.form.record = await CoursesService.GetCoursesbyId({ Id: this.courseId });
    else {
      this.form.record = {
        Enable: true

      } as ICoursesModel
    }
  },
  methods: {
    handleFileChange(_file: any) {
      if (_file) this.file = _file
    },
    cancel() {
      router.push({ name: "Courses" });
    },
    async load() {
      this.journeys = await JourneysService.GetJourneys();
      this.headquarters = await HeadquartersService.GetHeadquarters();
      this.categories = await CategoriesService.GetCategoryByKey('NIVELES_CURSOS');
    },
    async handleSubmit(event: any) {
      event.preventDefault();
      try {
        const res = await CoursesService.PostCourses(this.form.record);
        store.dispatch("core/popupDialog", {
          text: "Registro completado con éxito.",
          type: "success",
          showCancelButton: false,
        });
        this.form.record = res;
        router.push({ name: "CoursesDetails", params: { Id: this.form.record.Id } });

      } catch (err) {
        store.dispatch("core/popupDialog", {
          text: `Error ${err}`,
          type: "error",
          showCancelButton: false,
        });
      }
    },
  },
});
